<div class="title-block mb-3">
  <h4 class="card-title">{{ 'TR_STUDENTS' | translate }}</h4>
</div>

<div class="row">
  <div class="col-12">
    <div class="d-flex flex-wrap w-100">
      <div class="d-flex flex-1">
        <button *ngIf="student_create" class="mb-2 mr-2 btn btn-success create-user-btn"
          [title]="'TR_CREATE_STUDENT' | translate" [routerLink]="['student-form']">
          <i class="pe-7s-add-user"></i><span class="ml-2">{{ 'TR_CREATE' | translate }}</span>
        </button>
        <button *ngIf="student_create" class="mb-2 mr-2 btn btn-warning create-user-btn"
          (click)="openBulkUploadModal(studentsBulkUpload)">
          <span class="ml-2">{{ 'TR_STUDENTS_BULK_UPLOAD' | translate }}</span>
        </button>
      </div>
      <div class="filter-block" *ngIf="group_view" ngbDropdown>
        <button type="button" ngbDropdownToggle class="mb-2 btn btn-primary">{{ groupName ? groupName : 'TR_GROUPS' |
          translate }}</button>
        <div ngbDropdownMenu>
          <button class="dropdown-item" (click)="getAllStudents()">{{ 'TR_ALL' | translate }}</button>
          <button class="dropdown-item" *ngFor="let item of groups"
            (click)="getStudentsByGroup(item.id, item.groupName)">{{ item.groupName }}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="main-card mb-3 card">
  <div class="table-responsive scroll">
    <table class="align-middle mb-0 table table-striped table-hover">
      <thead>
        <tr>
          <th>{{ 'TR_DOCUMENT_NUMBER' | translate }}</th>
          <th>{{ 'TR_USERNAME' | translate }}</th>
          <th>{{ 'TR_FULLNAME' | translate }}</th>
          <th>{{ 'TR_GROUP_NAME' | translate }}</th>
          <th *ngIf="student_update || student_archive || student_delete">{{ 'TR_ACTIONS' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="pointer" title="Click to see full data" *ngFor="let item of students"
          (click)="studentView($event.target, studentview, item.id)">
          <td>{{ item.personalDocumentNumber }}</td>
          <td>{{ item.username }}</td>
          <td>{{ item.lastname }} {{ item.firstname }} {{ item.middlename }}</td>
          <td>{{ item.groupName }}</td>
          <td *ngIf="student_update || student_archive || student_delete" class="text-center">
            <div role="group" class="btn-group-sm btn-group">
              <button *ngIf="student_archive" class="ml-1 btn-transition btn"
                [ngClass]="item.isArchived ? 'btn-outline-success' : 'btn-outline-danger'"
                [title]="(item.isArchived ? 'TR_UNARCHIVE' : 'TR_ARCHIVE') | translate"
                (click)="confirmArchivation(archiveContent, item.id)">
                <i [ngClass]="item.isArchived ? 'pe-7s-check' : 'pe-7s-close-circle'"> </i>
              </button>
              <button *ngIf="student_update" class="ml-1 btn-transition btn btn-outline-info"
                [title]="'TR_UPDATE_STUDENT' | translate" [routerLink]="['student-form', item.id]">
                <i class="pe-7s-note"> </i>
              </button>
              <button *ngIf="student_delete" class="ml-1 btn-transition btn btn-outline-danger"
                [title]="'TR_DELETE' | translate" (click)="confirmDelete(deleteContent, item.id)">
                <i class="pe-7s-trash"> </i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #studentsBulkUpload let-c="close" let-d="dismiss">
  <app-students-bulk-upload (closeEmit)="c('Close click')"></app-students-bulk-upload>
</ng-template>

<ng-template #deleteContent let-c="close" let-d="dismiss">
  <div class="custom-modal modal-body">
    <p>{{ 'TR_DELETE_ERROR' | translate }} {{ deleteStudent.lastname }} {{ deleteStudent.firstname }} {{
      deleteStudent.middlename }} ? </p>
  </div>
  <div class="custom-modal modal-footer">
    <app-action-button [isCurrent]="true" [spinnerId]="userDeleteSpinnerId"
      buttonClasses="btn-transition btn btn-outline-primary" spinnerClasses="small-button-spinner"
      [buttonName]="'TR_YES'" (clicked)="delete()"></app-action-button>
    <button type="button" class="btn-transition btn btn-danger" (click)="c('Close click')">{{ 'TR_NO' | translate
      }}</button>
  </div>
</ng-template>

<ng-template #archiveContent let-c="close" let-d="dismiss">
  <div class="custom-modal modal-body">
    <p>{{ 'TR_ARE_YOU_SUTE' | translate }}
      {{ (isArchive ? 'TR_ARCHIVE' : 'TR_UNARCHIVE') | translate }}
      {{ archiveStudent.lastname }} {{ archiveStudent.firstname }} {{ archiveStudent.middlename }}?
    </p>
  </div>
  <div class="custom-modal modal-footer">
    <app-action-button [isCurrent]="true" [spinnerId]="userArchiveSpinnerId"
      buttonClasses="btn-transition btn btn-outline-primary" spinnerClasses="small-button-spinner"
      [buttonName]="'TR_YES'" (clicked)="triggerArchive()"></app-action-button>
    <button type="button" class="btn-transition btn btn-danger" (click)="c('Close click')">{{ 'TR_NO' | translate
      }}</button>
  </div>
</ng-template>

<ng-template #studentview let-c="close" let-d="dismiss">
  <app-student-view [studentId]="studentViewId" (closeEmit)="c('Close click')"></app-student-view>
</ng-template>